export const GENERIC_REQUEST_ERROR_MESSAGE =
  'Unable to complete your request. Please check your network connection and try again';

export const GENERIC_REQUEST_ERROR_MESSAGE_PRIMARY =
  'Unable to complete your request.';

export const GENERIC_REQUEST_ERROR_MESSAGE_SECONDARY =
  'Please check your network connection and try again.';

export const CREDENTIAL_ERROR_MESSAGE =
  'Error: Enter correct credential details.';
